module.exports = __webpack_public_path__ + "static/media/addQrCode.610d2c8b.svg";